var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.$vuetify.breakpoint.mobile ? _c('v-card', {
    staticClass: "px-12 py-8",
    attrs: {
      "color": "grey lighten-4",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--sm primary--text"
  }, [_vm._v(" 교환 내역 "), _c('v-spacer'), _c('v-btn', {
    staticStyle: {
      "border-radius": "8px!important"
    },
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("엑셀 다운로드")])], 1), _c('v-card-text', [_c('v-data-table', _vm._b({
    staticClass: "exchange-table",
    attrs: {
      "disable-filtering": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('v-layout', {
          staticClass: "pa-2",
          staticStyle: {
            "gap": "12px"
          },
          attrs: {
            "justify-end": "",
            "align-baseline": ""
          }
        }, [_c('span', [_vm._v(" 성공: " + _vm._s(_vm.success.format()) + "개 ")]), _c('span', [_vm._v(" 실패: " + _vm._s(_vm.failure.format()) + "개 ")]), _c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "to": "/mypage/exchange"
          }
        }, [_vm._v(" 내역보기 "), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 3540029315)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    itemsPerPage: -1
  }, false))], 1)], 1) : _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "grey lighten-4",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--sm primary--text justify-center"
  }, [_vm._v(" 교환권 번호 ")]), _c('v-card-text', [_c('v-row', {
    staticClass: "row--small"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item.tempId,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-sheet', {
      staticClass: "d-flex justify-center align-center",
      attrs: {
        "height": "40px"
      }
    }, [_vm._v(" " + _vm._s(item.prev || "-") + " ")])], 1)];
  })], 2)], 1)], 1), _c('v-sheet', {
    staticClass: "d-flex justify-center py-4"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-chevron-double-down")])], 1), _c('v-card', {
    attrs: {
      "color": "grey lighten-4",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--sm primary--text justify-center"
  }, [_vm._v(" 나누리 핀번호 ")]), _c('v-card-text', [_c('v-row', {
    staticClass: "row--small"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item.tempId,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-sheet', {
      staticClass: "d-flex justify-center align-center",
      attrs: {
        "height": "40px"
      }
    }, [_vm._v(" " + _vm._s(item.next || "-") + " ")])], 1)];
  })], 2)], 1)], 1), _c('v-sheet', {
    staticClass: "py-4"
  }, [_c('v-layout', {
    attrs: {
      "align-baseline": ""
    }
  }, [_c('v-layout', {
    staticClass: "px-4",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('span', [_vm._v(" 성공: " + _vm._s(_vm.success.format()) + "개 ")]), _c('span', [_vm._v(" 실패: " + _vm._s(_vm.failure.format()) + "개 ")])]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "to": "/mypage/exchange"
    }
  }, [_vm._v(" 내역보기 "), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }